/**
 * `TutorialProgressStore` 어댑터 — 완료 목록 + 재개 인덱스 맵을 SaveData에 위임하고 변경 시 persist.
 *
 * SaveData의 `tutorialCompleted: string[]` / `tutorialResume: Record<string, number>`를 getter로 받아
 * 인플레이스 갱신 후 persist 콜백을 호출한다(`SaveDataResetStore`가 dailyResets 맵에 위임하는 패턴과 동일).
 */
import type { TutorialProgressStore } from "@yjsgames/phaser-tutorial";

export class SaveDataTutorialStore implements TutorialProgressStore {
  constructor(
    private readonly getCompleted: () => string[],
    private readonly getResume: () => Record<string, number>,
    private readonly persist: () => void,
  ) {}

  isCompleted(scenarioId: string): boolean {
    return this.getCompleted().includes(scenarioId);
  }

  markCompleted(scenarioId: string): void {
    const list = this.getCompleted();
    if (!list.includes(scenarioId)) {
      list.push(scenarioId);
      this.persist();
    }
  }

  getResumeStep(scenarioId: string): number {
    return this.getResume()[scenarioId] ?? 0;
  }

  setResumeStep(scenarioId: string, stepIndex: number): void {
    this.getResume()[scenarioId] = stepIndex;
    this.persist();
  }
}
